"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5316],{

/***/ 2273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardLogo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(155);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9735);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9741);








function CardLogo(param) {
    var primary = param.primary, secondary = param.secondary, thumb = param.thumb, logo = param.logo, target = param.target, _type = param.type, type = _type === void 0 ? "hotel" : _type;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isHover = ref[0], setIsHover = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
        direction: "column",
        w: "100%",
        onMouseEnter: function() {
            return setIsHover(true);
        },
        onMouseLeave: function() {
            return setIsHover(false);
        },
        onClick: function() {
            return router.push(target);
        },
        cursor: "pointer",
        gap: 2,
        alignItems: "left",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                position: "relative",
                bg: "grey.300",
                w: "100%",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AbsoluteCenter */ .umj, {
                        zIndex: 6,
                        h: type == "dining" ? "45%" : "50%",
                        w: type == "dining" ? "65%" : "45%",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                            position: "relative",
                            h: "100%",
                            w: "100%",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_6__/* .convertImgHttps */ .Nu)(logo),
                                alt: "".concat(primary, " - ").concat(secondary, " logo"),
                                layout: "fill",
                                objectFit: "contain",
                                priority: true,
                                unoptimized: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AbsoluteCenter */ .umj, {
                        bg: isHover ? "blackAlpha.700" : "blackAlpha.400",
                        zIndex: 5,
                        h: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_7__/* .cardWidthQuery */ .Z0,
                        w: "100%",
                        transition: "all 1s cubic-bezier(0.33, 1, 0.68, 1)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                        position: "relative",
                        h: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_7__/* .cardWidthQuery */ .Z0,
                        w: "100%",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_6__/* .convertImgHttps */ .Nu)(thumb),
                            alt: "".concat(primary, " - ").concat(secondary, " thumb"),
                            objectFit: "cover",
                            layout: "fill",
                            priority: true,
                            unoptimized: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                maxW: "100%",
                align: "center",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                        noOfLines: 1,
                        fontSize: "sm",
                        textTransform: "uppercase",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: primary
                            }),
                            " - ",
                            secondary
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_5__/* .IoArrowForward */ .qvS, {
                        fontWeight: 300,
                        size: 20
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 7423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ BookNowContext; },
  "Z": function() { return /* binding */ FormBookNowV2; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/index.mjs + 808 modules
var dist = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var index_esm = __webpack_require__(155);
// EXTERNAL MODULE: ./src/utils/const.js
var utils_const = __webpack_require__(3026);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
// EXTERNAL MODULE: ./node_modules/dayzed/dist/dayzed.esm.js
var dayzed_esm = __webpack_require__(5845);
;// CONCATENATED MODULE: ./src/components/DatePickerV2.jsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








function Calendar(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
        w: "100%",
        children: props.children
    });
}
function Month(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SimpleGrid */.MIq, {
        columns: 7,
        spacing: 0,
        children: props.children
    });
}
function DayOfMonth(_param) {
    var _unavailable = _param.unavailable, unavailable = _unavailable === void 0 ? false : _unavailable, _today = _param.today, today = _today === void 0 ? false : _today, isInRange = _param.isInRange, props = _objectWithoutProperties(_param, [
        "unavailable",
        "today",
        "isInRange"
    ]);
    var selected = props.selected;
    // let cellStyle = "";
    // if (today) cellStyle = "bg-blue-200 text-blue-900";
    // if (selected || isInRange) cellStyle = "bg-purple-200 text-purple-900";
    // if (unavailable) cellStyle = "opacity-25 cursor-not-allowed";
    var selectedStyle = {
        background: "white",
        // borderRadius: `50%`,
        color: "black",
        fontWeight: 600
    };
    var inRangeStyle = {
        backgroundColor: "var(--chakra-colors-whiteAlpha-500)"
    };
    var finalStyle = selected ? inRangeStyle : isInRange ? inRangeStyle : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
        pt: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AspectRatio */.oM5, {
            ratio: 4 / 3,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                style: finalStyle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, _objectSpread({
                    color: unavailable ? "whiteAlpha.500" : selected ? "black" : "white",
                    cursor: unavailable ? "not-allowed" : "pointer"
                }, props, {
                    children: selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AbsoluteCenter */.umj, {
                        w: "100%",
                        h: "100%",
                        style: selectedStyle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                            w: "100%",
                            h: "100%",
                            children: props.children
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                        children: props.children
                    })
                }))
            })
        })
    });
}
function DayOfMonthEmpty(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: props.children
    });
}
function RangeDatepicker(props) {
    var getKeyOffset = function getKeyOffset(number) {
        var e = document.activeElement;
        var buttons = document.querySelectorAll("button");
        buttons.forEach(function(el, i) {
            var newNodeKey = i + number;
            if (el == e) {
                if (newNodeKey <= buttons.length - 1 && newNodeKey >= 0) {
                    buttons[newNodeKey].focus();
                } else {
                    buttons[0].focus();
                }
            }
        });
    };
    var onMouseLeave = function onMouseLeave() {
        setHoveredDate(null);
    };
    var onMouseEnter = function onMouseEnter(date) {
        if (!props.selected.length) return;
        setHoveredDate(date);
    };
    var isInRange = function isInRange(date) {
        var selected = props.selected;
        if (selected.length) {
            var firstSelected = selected[0].getTime();
            if (selected.length === 2) {
                var secondSelected = selected[1].getTime();
                return firstSelected < date && secondSelected > date;
            } else {
                return hoveredDate && (firstSelected < date && hoveredDate >= date || date < firstSelected && date >= hoveredDate);
            }
        }
        return false;
    };
    var ref = (0,react.useContext)(BookNowContext), values = ref.values, setValues = ref.setValues;
    var ref1 = (0,react.useState)(null), hoveredDate = ref1[0], setHoveredDate = ref1[1];
    var ref2 = (0,dayzed_esm/* useDayzed */.A)(props), calendars = ref2.calendars, getBackProps = ref2.getBackProps, getForwardProps = ref2.getForwardProps, getDateProps = ref2.getDateProps, showOutsideDays = ref2.showOutsideDays;
    (0,react.useEffect)(function() {
        var navigate = function navigate(e) {
            switch(e.keyCode){
                case 37:
                    getKeyOffset(-1);
                    break;
                case 38:
                    getKeyOffset(-7);
                    break;
                case 39:
                    getKeyOffset(1);
                    break;
                case 40:
                    getKeyOffset(7);
                    break;
                default:
                    break;
            }
        };
        addEventListener("keydown", navigate);
        return function() {
            return removeEventListener("keydown", navigate);
        };
    });
    var router = (0,next_router.useRouter)();
    if (calendars.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
            flexDir: "column",
            h: "100%",
            w: "100%",
            bg: "blackAlpha.900",
            color: "white",
            fontSize: "xs",
            textTransform: "uppercase",
            py: 8,
            px: 6,
            borderRadius: 10,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                    gap: 20,
                    children: calendars.map(function(calendar, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                            flexDir: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                    w: "100%",
                                    justify: "space-between",
                                    alignItems: "center",
                                    children: [
                                        i == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", _objectSpread({}, getBackProps({
                                            calendars: calendars
                                        }), {
                                            style: {
                                                opacity: calendars[0].weeks[0][0].prevMonth ? 1 : 0.4,
                                                cursor: calendars[0].weeks[0][0].prevMonth ? "pointer" : "not-allowed"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoChevronBack */.dUf, {
                                                size: 20
                                            })
                                        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                            w: "20px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                            alignSelf: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                                                as: "span",
                                                fontWeight: 500,
                                                fontSize: "md",
                                                children: [
                                                    (router.locale == "id" ? monthNamesFullId : monthNamesFullEn)[calendar.month],
                                                    " ",
                                                    calendar.year
                                                ]
                                            })
                                        }),
                                        i == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", _objectSpread({}, getForwardProps({
                                            calendars: calendars
                                        }), {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoChevronForward */.mzm, {
                                                size: 20
                                            })
                                        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                            w: "20px"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                                    my: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                        orientation: "horizontal",
                                        borderColor: "whiteAlpha.700"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SimpleGrid */.MIq, {
                                    columns: 7,
                                    columnGap: 2,
                                    children: (router.locale == "id" ? weekdayNamesShortId : weekdayNamesShortEn).map(function(weekday) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                                fontWeight: 500,
                                                textAlign: "center",
                                                children: weekday
                                            })
                                        }, "".concat(calendar.month).concat(calendar.year).concat(weekday));
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SimpleGrid */.MIq, {
                                    columns: 7,
                                    textAlign: "center",
                                    cursor: "default",
                                    children: calendar.weeks.map(function(week, windex) {
                                        return week.map(function(dateObj, index) {
                                            var key = "".concat(calendar.month).concat(calendar.year).concat(windex).concat(index);
                                            if (!dateObj) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DayOfMonthEmpty, {}, key);
                                            }
                                            var date = dateObj.date, selected = dateObj.selected, selectable = dateObj.selectable, today = dateObj.today, nextMonth = dateObj.nextMonth, prevMonth = dateObj.prevMonth;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DayOfMonth, _objectSpread({}, getDateProps({
                                                dateObj: dateObj,
                                                onMouseEnter: function() {
                                                    return onMouseEnter(date);
                                                }
                                            }), {
                                                selected: selected,
                                                unavailable: !selectable || prevMonth || nextMonth,
                                                today: today,
                                                isInRange: isInRange(date),
                                                children: date.getDate()
                                            }), key);
                                        });
                                    })
                                })
                            ]
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                    mt: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                        borderColor: "whiteAlpha.400",
                        size: "sm",
                        variant: "outlineBlack",
                        mt: 2,
                        onClick: function() {
                            setValues(_objectSpread({}, values, {
                                arrivePop: false
                            }));
                        },
                        children: router.locale == "id" ? "Selesai" : "Done"
                    })
                })
            ]
        });
    }
    if (calendars.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Calendar, {
            onMouseLeave: onMouseLeave,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                    bg: "blackAlpha.900",
                    color: "white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", _objectSpread({}, getBackProps({
                            calendars: calendars
                        }), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoChevronBack */.dUf, {
                                size: 20
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", _objectSpread({}, getForwardProps({
                            calendars: calendars
                        }), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoChevronForward */.mzm, {
                                size: 20
                            })
                        }))
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                    bg: "grey.400",
                    color: "white",
                    children: [
                        calendars.map(function(calendar, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                bg: "yellow.300",
                                margin: 2,
                                children: [
                                    (router.locale == "id" ? monthNamesFullId : monthNamesFullEn)[calendar.month],
                                    " ",
                                    calendar.year
                                ]
                            }, i);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                            children: calendars.map(function(calendar) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Month, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                            bg: "pink.300",
                                            margin: 2,
                                            children: [
                                                (router.locale == "id" ? monthNamesFullId : monthNamesFullEn)[calendar.month],
                                                " ",
                                                calendar.year
                                            ]
                                        }),
                                        (router.locale == "id" ? weekdayNamesShortId : weekdayNamesShortEn).map(function(weekday) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DayOfMonthEmpty, {
                                                children: weekday
                                            }, "".concat(calendar.month).concat(calendar.year).concat(weekday));
                                        }),
                                        calendar.weeks.map(function(week, windex) {
                                            return week.map(function(dateObj, index) {
                                                var key = "".concat(calendar.month).concat(calendar.year).concat(windex).concat(index);
                                                if (!dateObj) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DayOfMonthEmpty, {}, key);
                                                }
                                                var date = dateObj.date, selected = dateObj.selected, selectable = dateObj.selectable, today = dateObj.today;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DayOfMonth, _objectSpread({}, getDateProps({
                                                    dateObj: dateObj,
                                                    onMouseEnter: function() {
                                                        return onMouseEnter(date);
                                                    }
                                                }), {
                                                    selected: selected,
                                                    unavailable: !selectable,
                                                    today: today,
                                                    isInRange: isInRange(date),
                                                    children: date.getDate()
                                                }), key);
                                            });
                                        })
                                    ]
                                }, "".concat(calendar.month).concat(calendar.year));
                            })
                        })
                    ]
                })
            ]
        });
    }
    return null;
}
var formatDateISO = function(date) {
    if (!date) return "";
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    return "".concat(year, "-").concat(month, "-").concat(day);
};
function Range(props) {
    var _handleOnDateSelected = function _handleOnDateSelected(param) {
        var selected = param.selected, selectable = param.selectable, date = param.date;
        if (!selectable) return;
        var dateTime = date.getTime();
        var newDates = _toConsumableArray(selectedDates);
        if (selectedDates.length) {
            if (selectedDates.length === 1) {
                var firstTime = selectedDates[0].getTime();
                if (firstTime < dateTime) newDates.push(date);
                else newDates.unshift(date);
                setSelectedDates(newDates);
                setValues(_objectSpread({}, values, {
                    arrive: formatDateISO(newDates[0]),
                    depart: formatDateISO(newDates[1])
                }));
            } else if (newDates.length === 2) {
                setSelectedDates([
                    date
                ]);
                setValues(_objectSpread({}, values, {
                    arrive: formatDateISO([
                        date
                    ][0])
                }));
            }
        } else {
            newDates.push(date);
            setSelectedDates(newDates);
            setValues(newDates.length == 2 ? _objectSpread({}, values, {
                arrive: formatDateISO(newDates[0]),
                depart: formatDateISO(newDates[1])
            }) : _objectSpread({}, values, {
                arrive: formatDateISO(newDates[0])
            }));
        }
    };
    var ref = (0,react.useContext)(BookNowContext), values = ref.values, setValues = ref.setValues;
    var ref3 = (0,react.useState)([]), selectedDates = ref3[0], setSelectedDates = ref3[1];
    var ref4 = (0,react.useState)(new Date()), date1 = ref4[0];
    (0,react.useEffect)(function() {
        if (!(0,lodash.isEmpty)(values.depart) && !(0,lodash.isEmpty)(values.arrive)) {
            var temp = [
                new Date(values.arrive),
                new Date(values.depart)
            ];
            setSelectedDates(_toConsumableArray(temp));
        }
        if (!(0,lodash.isEmpty)(values.arrive)) {
            setSelectedDates([
                new Date(values.arrive)
            ]);
        }
    }, []);
    var minDate = new Date();
    minDate.setDate(minDate.getDate() - 1);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeDatepicker, {
        showOutsideDays: true,
        minDate: minDate,
        date: date1,
        selected: selectedDates,
        onDateSelected: _handleOnDateSelected,
        monthsToDisplay: 2
    });
}
/* harmony default export */ var DatePickerV2 = (Range);
var monthNamesFullEn = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December", 
];
var monthNamesFullId = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember", 
];
var monthNamesShort = (/* unused pure expression or super */ null && ([
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec", 
]));
var weekdayNamesShortEn = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat", 
];
var weekdayNamesShortId = [
    "Min",
    "Sen",
    "Sel",
    "Rab",
    "Kam",
    "Jum",
    "Sab", 
];

;// CONCATENATED MODULE: ./src/components/FormBookNowV2.tsx
function FormBookNowV2_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function FormBookNowV2_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return FormBookNowV2_arrayLikeToArray(arr);
}
function FormBookNowV2_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FormBookNowV2_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function FormBookNowV2_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function FormBookNowV2_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FormBookNowV2_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FormBookNowV2_toConsumableArray(arr) {
    return FormBookNowV2_arrayWithoutHoles(arr) || FormBookNowV2_iterableToArray(arr) || FormBookNowV2_unsupportedIterableToArray(arr) || FormBookNowV2_nonIterableSpread();
}
function FormBookNowV2_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return FormBookNowV2_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return FormBookNowV2_arrayLikeToArray(o, minLen);
}








// import { BookNowContext } from "../utils/hooks";

var UnsafeFlex = dist/* Flex */.kCb;
var UnsafeText = dist/* Text */.xvT;
var UnsafeButton = dist/* Button */.zxk;
var UnsafeDivider = dist/* Divider */.izJ;
var UnsafeBox = dist/* Box */.xuv;
var hotelList = [
    {
        location: "tangerang",
        list: [
            "Atria Hotel Gading Serpong",
            "Atria Residences Gading Serpong",
            "Vega Hotel Gading Serpong",
            "Fame Hotel Gading Serpong",
            "Starlet Hotel Serpong",
            "Starlet Hotel BSD City", 
        ],
        code: [
            36461,
            36462,
            36463,
            36464,
            36465,
            36471
        ]
    },
    {
        location: "jakarta",
        list: [
            "Starlet Hotel Jakarta Airport"
        ],
        code: [
            36470
        ]
    },
    // { location: "SEMARANG", list: ["HA-KA Hotel Semarang"], code: [36469] },
    {
        location: "magelang",
        list: [
            "Atria Hotel Magelang"
        ],
        code: [
            36467
        ]
    },
    {
        location: "malang",
        list: [
            "Atria Hotel Malang"
        ],
        code: [
            36466
        ]
    },
    {
        location: "bali",
        list: [
            "Fame Hotel Sunset Road Bali"
        ],
        code: [
            36468
        ]
    }, 
];
var BookNowContext = /*#__PURE__*/ (0,react.createContext)(null);
function FormBookNowV2(param) {
    var hotelCode = param.hotelCode, colorPrimary = param.colorPrimary;
    var handleClick = function handleClick() {
        if (!values.hotel) {
            setValues(FormBookNowV2_objectSpread({}, values, {
                hotel_error: true,
                hotelPop: true
            }));
            return;
        }
        var bookingConfig = (0,functions/* getBookingEngineHotelConfig */.Np)(hotel);
        if (!bookingConfig) return;
        (0,functions/* submitBookingEngineForm */.Sw)({
            action: bookingConfig.action,
            fields: {
                language: (0,functions/* getBookingEngineLocale */.cG)(router.locale),
                arrivalDate: (0,lodash.isEmpty)(arrive) ? "" : arrive,
                nights: (0,functions/* getBookingEngineNights */.cl)(arrive, depart),
                guestCountSelector: "ReadOnly",
                crossSell: "false",
                selectedAdultCount: adult,
                selectedChildCount: child,
                rate: promo
            }
        });
    };
    var router = (0,next_router.useRouter)();
    var container = (0,react.useRef)(null);
    var ref = (0,react.useState)(), hotelValue = ref[0], setHotelvalue = ref[1];
    // const [hotelPop, setHotelPop] = useState<boolean>(false);
    var ref1 = (0,react.useState)(false), arrivePop = ref1[0], setArrivePop = ref1[1];
    var ref2 = (0,react.useState)({
        hotel_name: "",
        hotel: hotelCode ? hotelCode : null,
        hotel_error: false,
        arrive: (0,functions/* getLocalStorage */.$o)("booking_arrival", ""),
        depart: (0,functions/* getLocalStorage */.$o)("booking_departure", ""),
        adult: 2,
        child: 0,
        childAge: [],
        room: 1,
        voucher: null,
        promo: "",
        hotelPop: false,
        arrivePop: false,
        deparPop: false,
        roomPop: false,
        promoPop: false
    }), values = ref2[0], setValues = ref2[1];
    (0,react.useEffect)(function() {
        if (values === null || values === void 0 ? void 0 : values.arrive) {
            (0,functions/* setLocalStorage */.qQ)("booking_arrival", values.arrive);
        }
    }, [
        values === null || values === void 0 ? void 0 : values.arrive
    ]);
    (0,react.useEffect)(function() {
        if (values === null || values === void 0 ? void 0 : values.depart) {
            (0,functions/* setLocalStorage */.qQ)("booking_departure", values.depart);
        }
    }, [
        values === null || values === void 0 ? void 0 : values.depart
    ]);
    var hotel_name = values.hotel_name, hotel = values.hotel, arrive = values.arrive, depart = values.depart, adult = values.adult, child = values.child, room = values.room, voucher = values.voucher, childAge = values.childAge, promo = values.promo;
    // useEffect(() => {
    //   if (container) {
    //     getHeight(container.current.offsetHeight);
    //   }
    // }, []);
    (0,react.useEffect)(function() {
        if (hotelCode) {
            for(var i = 0; i < hotelList.length; i++){
                for(var j = 0; j < hotelList[i].code.length; j++){
                    if (hotelList[i].code[j] == hotelCode) {
                        setValues(FormBookNowV2_objectSpread({}, values, {
                            hotel_name: hotelList[i].list[j]
                        }));
                    }
                }
            }
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BookNowContext.Provider, {
        value: {
            values: values,
            setValues: setValues
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
            ref: container,
            display: {
                base: "none",
                lg: "block"
            },
            zIndex: 50,
            w: "100%",
            py: 6,
            className: "book-now-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                mx: 100,
                justifyContent: "space-between",
                alignItems: "center",
                gap: 6,
                children: [
                    values.hotelPop && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        zIndex: 51,
                        position: "absolute",
                        bottom: "160%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelPopUp, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField, {
                        title: router.locale == "id" ? "hotel" : "hotels",
                        desc: !(0,lodash.isEmpty)(hotel_name) ? hotel_name : router.locale == "id" ? "Pilih hotel" : "Select a Hotel",
                        flex: 31,
                        onClick: function() {
                            setValues(FormBookNowV2_objectSpread({}, values, {
                                hotelPop: !values.hotelPop,
                                arrivePop: false,
                                roomPop: false,
                                promoPop: false
                            }));
                        }
                    }),
                    values.arrivePop && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        zIndex: 51,
                        position: "absolute",
                        bottom: "160%",
                        left: "27%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePopUp, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField, {
                        title: router.locale == "id" ? "tanggal" : "dates",
                        desc: arrive && depart ? (0,functions/* getFormDate */.Pd)([
                            (0,functions/* timeConvertion */.mQ)({
                                UNIX_timestamp: Math.floor(new Date(arrive).getTime() / 1000),
                                months: router.locale == "id" ? utils_const/* monthId */.Cf : utils_const/* monthEn */.Ic
                            }),
                            (0,functions/* timeConvertion */.mQ)({
                                UNIX_timestamp: Math.floor(new Date(depart).getTime() / 1000),
                                months: router.locale == "id" ? utils_const/* monthId */.Cf : utils_const/* monthEn */.Ic
                            }), 
                        ]) : router.locale == "id" ? "Kedatangan - Keberangkatan" : "Arrival - Departure",
                        flex: 31,
                        onClick: function() {
                            setValues(FormBookNowV2_objectSpread({}, values, {
                                hotelPop: false,
                                arrivePop: !values.arrivePop,
                                roomPop: false,
                                promoPop: false
                            }));
                        }
                    }),
                    values.roomPop && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        zIndex: 51,
                        position: "absolute",
                        bottom: "160%",
                        left: "48%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomPopUp, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField, {
                        title: router.locale == "id" ? "tamu dan kamar" : "guests and rooms",
                        desc: "".concat(adult, " ").concat(router.locale == "id" ? "Dewasa" : "Adult(s)", ", ").concat(child, " ").concat(router.locale == "id" ? "Anak" : "Child", ", ").concat(room, " ").concat(router.locale == "id" ? "Ruangan" : "Room"),
                        flex: 33,
                        onClick: function() {
                            setValues(FormBookNowV2_objectSpread({}, values, {
                                hotelPop: false,
                                arrivePop: false,
                                roomPop: !values.roomPop,
                                promoPop: false
                            }));
                        }
                    }),
                    values.promoPop && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        zIndex: 51,
                        position: "absolute",
                        bottom: "160%",
                        right: "10%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                            flexDir: "column",
                            w: 300,
                            bg: "blackAlpha.900",
                            gap: 4,
                            p: 4,
                            borderRadius: 10,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Input */.IIB, {
                                    placeholder: router.locale == "id" ? "KETIK DISINI" : "TYPE IN HERE",
                                    fontSize: "sm",
                                    borderColor: "whiteAlpha.500",
                                    borderRadius: 0,
                                    color: "white",
                                    w: "100%",
                                    onChange: function(e) {
                                        return setValues(FormBookNowV2_objectSpread({}, values, {
                                            promo: e.target.value
                                        }));
                                    },
                                    onKeyDown: function(e) {
                                        if (e.key === "Enter") {
                                            setValues(FormBookNowV2_objectSpread({}, values, {
                                                hotelPop: false,
                                                arrivePop: false,
                                                roomPop: false,
                                                promoPop: !values.promoPop
                                            }));
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                        borderColor: "whiteAlpha.400",
                                        size: "sm",
                                        variant: "outlineBlack",
                                        mt: 2,
                                        onClick: function() {
                                            setValues(FormBookNowV2_objectSpread({}, values, {
                                                promoPop: false
                                            }));
                                        },
                                        children: router.locale == "id" ? "Selesai" : "Done"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField, {
                        title: router.locale == "id" ? "kode promo" : "promo code",
                        desc: values.promo ? values.promo : router.locale == "id" ? "Masukkan" : "Insert",
                        flex: 20,
                        hasDivider: false,
                        onClick: function() {
                            setValues(FormBookNowV2_objectSpread({}, values, {
                                hotelPop: false,
                                arrivePop: false,
                                roomPop: false,
                                promoPop: !values.promoPop
                            }));
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                        colorScheme: "whiteAlpha",
                        width: "15%",
                        maxW: 300,
                        onClick: handleClick,
                        zIndex: 20,
                        fontWeight: 500,
                        children: router.locale == "id" ? "Pesan" : "Book Now"
                    })
                ]
            })
        })
    });
};
function FormField(param) {
    var title = param.title, desc = param.desc, flex = param.flex, onClick = param.onClick, _hasDivider = param.hasDivider, hasDivider = _hasDivider === void 0 ? true : _hasDivider;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                width: flex + "%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                    direction: "column",
                    color: "white",
                    gap: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                            textTransform: "uppercase",
                            color: "white",
                            fontSize: "sm",
                            letterSpacing: "wider",
                            noOfLines: 1,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                            alignItems: "center",
                            justifyContent: "space-between",
                            onClick: onClick,
                            cursor: "pointer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                                    className: "max-text-1-line",
                                    w: "100%",
                                    fontWeight: 500,
                                    letterSpacing: "wider",
                                    children: desc
                                }),
                                hasDivider ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoChevronDown */.CgR, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {})
                            ]
                        })
                    ]
                })
            }),
            hasDivider && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                height: "56px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeDivider, {
                    orientation: "vertical",
                    borderColor: "whiteAlpha.700"
                })
            })
        ]
    });
}
function HotelPopUp() {
    var ref = (0,react.useContext)(BookNowContext), values = ref.values, setValues = ref.setValues;
    var locale = (0,next_router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                bg: "red.700",
                borderRadius: 10,
                mb: 2,
                display: values.hotel_error ? "flex" : "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                    color: "white",
                    opacity: 1,
                    fontSize: "xs",
                    py: 2,
                    px: 5,
                    children: locale == "id" ? "Silakan pilih Hotel terlebih dahulu" : "Please select a Hotel first"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeBox, {
                bg: "blackAlpha.900",
                py: 6,
                px: 5,
                borderRadius: 10,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                    gap: 14,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LocToHotel, {
                            loc: hotelList[0].location,
                            list: hotelList[0].list,
                            code: hotelList[0].code
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                            direction: "column",
                            gap: 5,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocToHotel, {
                                    loc: hotelList[1].location,
                                    list: hotelList[1].list,
                                    code: hotelList[1].code
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocToHotel, {
                                    loc: hotelList[2].location,
                                    list: hotelList[2].list,
                                    code: hotelList[2].code
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocToHotel, {
                                    loc: hotelList[3].location,
                                    list: hotelList[3].list,
                                    code: hotelList[3].code
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                            direction: "column",
                            gap: 5,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocToHotel, {
                                loc: hotelList[4].location,
                                list: hotelList[4].list,
                                code: hotelList[4].code
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function LocToHotel(param) {
    var loc = param.loc, list = param.list, code = param.code;
    var ref = (0,react.useContext)(BookNowContext), values = ref.values, setValues = ref.setValues;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
        flexDir: "column",
        textTransform: "uppercase",
        gap: 3,
        fontSize: "x-small",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                color: "white",
                fontWeight: 600,
                letterSpacing: 4,
                children: loc
            }),
            list.map(function(name, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                    color: "whiteAlpha.800",
                    letterSpacing: 1,
                    cursor: "pointer",
                    onClick: function() {
                        setValues(FormBookNowV2_objectSpread({}, values, {
                            hotel: code[i],
                            hotel_name: name,
                            hotelPop: false,
                            hotel_error: false
                        }));
                    },
                    _hover: {
                        color: "white"
                    },
                    children: name
                }, name);
            })
        ]
    });
}
function DatePopUp() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
        className: "date-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerV2, {})
    });
}
function RoomPopUp() {
    var _loop = function(i) {
        items.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                    fontSize: ".75em",
                    mb: 1,
                    children: [
                        "CHILD ",
                        i + 1
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Select */.PhF, {
                    fontSize: ".8em",
                    placeholder: "Age",
                    border: "1px",
                    borderColor: "whiteAlpha.400",
                    paddingInline: 0,
                    paddingInlineEnd: 0,
                    borderRadius: 0,
                    color: "whiteAlpha.700",
                    iconSize: "12px",
                    variant: "outline",
                    value: el[i],
                    onChange: function(e) {
                        var temp = FormBookNowV2_toConsumableArray(el);
                        temp[i] = e.target.value;
                        setEl(temp);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 0,
                            children: "< 1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 1,
                            children: "1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 2,
                            children: "2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 3,
                            children: "3"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 4,
                            children: "4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 5,
                            children: "5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 6,
                            children: "6"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 7,
                            children: "7"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 8,
                            children: "8"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 9,
                            children: "9"
                        })
                    ]
                })
            ]
        }, i));
    };
    var ref = (0,react.useContext)(BookNowContext), values = ref.values, setValues = ref.setValues;
    var adult1 = values.adult, child1 = values.child, childAge = values.childAge, room1 = values.room;
    var ref3 = (0,react.useState)(childAge ? childAge : []), el = ref3[0], setEl = ref3[1];
    var items = [];
    var router = (0,next_router.useRouter)();
    for(var i = 0; i < child1; i++)_loop(i);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !(child1 < 9 || room1 < 9) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                bg: "red.700",
                mb: 2,
                py: 2,
                px: 20,
                maxW: "100%",
                borderRadius: 10,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                    color: "white",
                    fontSize: "xs",
                    as: "span",
                    maxInlineSize: "44",
                    align: "center",
                    children: "Maximum number of rooms and child become 9"
                })
            }),
            !(room1 <= adult1) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                bg: "red.700",
                mb: 2,
                py: 2,
                px: 10,
                maxW: "100%",
                borderRadius: 10,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                    color: "white",
                    fontSize: "xs",
                    as: "span",
                    maxInlineSize: "56",
                    align: "center",
                    children: "Number of room (s) can't be more than number of adult guest(s)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                direction: "column",
                borderRadius: 10,
                bg: "blackAlpha.900",
                color: "white",
                px: 6,
                pt: 5,
                pb: 3,
                w: 430,
                fontSize: "sm",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomPopSelect, {
                        setValue: function(adult) {
                            return setValues(FormBookNowV2_objectSpread({}, values, {
                                adult: adult
                            }));
                        },
                        value: adult1,
                        name: router.locale == "id" ? "dewasa" : "adult",
                        warning: undefined
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomPopSelect, {
                        setValue: function(child) {
                            return setValues(FormBookNowV2_objectSpread({}, values, {
                                child: child
                            }));
                        },
                        value: child1,
                        name: router.locale == "id" ? "anak" : "child",
                        warning: "Max. 9 children",
                        max: 9
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomPopSelect, {
                        setValue: function(room) {
                            return setValues(FormBookNowV2_objectSpread({}, values, {
                                room: room
                            }));
                        },
                        value: room1,
                        name: router.locale == "id" ? "ruangan" : "room",
                        warning: "Max. 9 rooms",
                        max: 9
                    }),
                    child1 > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                                fontSize: "xs",
                                my: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        children: "ENTER CHILD'S AGES"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        color: "whiteAlpha.600",
                                        fontSize: ".9em",
                                        children: "Knowing your children's ages will help us find you suitable accomodations"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SimpleGrid */.MIq, {
                                columns: 5,
                                spacing: 2,
                                fontSize: "xs",
                                children: items
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeButton, {
                            borderColor: "whiteAlpha.400",
                            size: "sm",
                            variant: "outlineBlack",
                            mt: 2,
                            onClick: function() {
                                var temp = el.slice(0, child1);
                                setValues(FormBookNowV2_objectSpread({}, values, {
                                    roomPop: false,
                                    childAge: temp
                                }));
                            },
                            children: router.locale == "id" ? "Selesai" : "Done"
                        })
                    })
                ]
            })
        ]
    });
}
function RoomPopSelect(param) {
    var name = param.name, warning = param.warning, value = param.value, setValue = param.setValue, _max = param.max, max = _max === void 0 ? 99 : _max;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
        justify: "space-between",
        align: "center",
        border: "1px",
        px: 4,
        py: 2,
        borderColor: "whiteAlpha.400",
        fontSize: "xs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                align: "center",
                gap: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsafeText, {
                        textTransform: "uppercase",
                        children: name
                    }),
                    value >= max && warning && /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeText, {
                        fontSize: ".8em",
                        color: "red.400",
                        children: [
                            "(",
                            warning,
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnsafeFlex, {
                justify: "space-between",
                align: "center",
                w: 90,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoRemoveCircleOutline */.MPJ, {
                        onClick: function() {
                            value > 0 && setValue(value - 1);
                        },
                        size: 20,
                        opacity: value > 0 ? 1 : 0.4,
                        cursor: value > 0 ? "pointer" : "not-allowed"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                        children: value
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoAddCircleOutline */.RWZ, {
                        onClick: function() {
                            value < max && setValue(value + 1);
                        },
                        size: 20,
                        opacity: value < max ? 1 : 0.4,
                        cursor: value < max ? "pointer" : "not-allowed"
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 2699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeroV2; }
/* harmony export */ });
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(870);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_effect_creative__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9180);
/* harmony import */ var swiper_css_effect_creative__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_creative__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8352);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7239);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9735);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9741);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}














function HeroV2(param1) {
    var heroItem = param1.heroItem, _hasFormNow = param1.hasFormNow, hasFormNow = _hasFormNow === void 0 ? false : _hasFormNow, height = param1.height;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(), query = ref.query, isReady = ref.isReady;
    var bulletsRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var isLarge = (0,_utils_mediaQuery__WEBPACK_IMPORTED_MODULE_13__/* .useLargeQuery */ .fc)().isLarge;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), sliderCaptions = ref1[0], setSliderCaptions = ref1[1];
    var id1 = heroItem.id, name = heroItem.name, banner = heroItem.banner, color_primary = heroItem.color_primary, hotel_code = heroItem.hotel_code, slider = heroItem.slider, is_parador = heroItem.is_parador, has_banner = heroItem.has_banner;
    var BannerHeading = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q;
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        function f() {
            return _f.apply(this, arguments);
        }
        function _f() {
            _f = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1() {
                var temp;
                return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
                    while(1)switch(_ctx1.prev = _ctx1.next){
                        case 0:
                            _ctx1.next = 2;
                            return Promise.all(slider.map(function() {
                                var _ref = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
                                    var id, x, y;
                                    return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                id = param.id;
                                                _ctx.next = 3;
                                                return (0,_utils_api__WEBPACK_IMPORTED_MODULE_11__/* .getWPImage */ .Mu)(id);
                                            case 3:
                                                x = _ctx.sent;
                                                _ctx.next = 6;
                                                return x.data.caption;
                                            case 6:
                                                y = _ctx.sent;
                                                if (y) {
                                                    y = y.rendered.replace("<p>", "").replace("</p>\n", "");
                                                }
                                                return _ctx.abrupt("return", y);
                                            case 9:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }()));
                        case 2:
                            temp = _ctx1.sent;
                            setSliderCaptions(temp);
                        case 4:
                        case "end":
                            return _ctx1.stop();
                    }
                }, _callee1);
            }));
            return _f.apply(this, arguments);
        }
        f();
    }, [
        isReady
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
        className: "hero-container-v2",
        ref: containerRef,
        h: "800px",
        maxH: "800px",
        children: [
            !is_parador || has_banner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BannerHeading, {
                className: "banner",
                as: "h1",
                size: "lg",
                fontWeight: 300,
                letterSpacing: "widestx",
                textAlign: "center",
                children: banner
            }) : null,
            slider && slider.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_10__/* .Swiper */ .tq, {
                lazy: true,
                centeredSlides: true,
                speed: 1000,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
                loop: slider.length > 1,
                pagination: {
                    clickable: true
                },
                navigation: true,
                modules: slider.length > 1 ? [
                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt,
                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .Pagination */ .tl,
                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .Navigation */ .W_
                ] : [],
                className: "mySwiper",
                onInit: function(swiper) {
                    if (slider.length > 1) {
                        swiper.navigation.init();
                        swiper.navigation.update();
                    }
                },
                children: slider && slider.map(function(image, i) {
                    var _i;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_10__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                            className: "image-container",
                            h: "800px",
                            width: "100%",
                            children: [
                                !(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(sliderCaptions[i]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                    className: "slider-caption",
                                    zIndex: 9,
                                    position: "absolute",
                                    fontWeight: 500,
                                    fontSize: [
                                        "x-small",
                                        "small"
                                    ],
                                    bottom: [
                                        "2px",
                                        "24px"
                                    ],
                                    opacity: [
                                        0.5,
                                        1
                                    ],
                                    right: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_13__/* .safeMarginX */ .Mp,
                                    color: "white",
                                    children: (_i = sliderCaptions[i]) !== null && _i !== void 0 ? _i : ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    h: "100%",
                                    w: "100%",
                                    bg: is_parador && hasFormNow ? "blackAlpha.400" : "blackAlpha.700",
                                    zIndex: 5
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    className: "image-slider",
                                    src: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_12__/* .convertImgHttps */ .Nu)(image.url),
                                    alt: "".concat(name, " slide ").concat(i + 1),
                                    layout: "fill",
                                    sizes: "(max-width: 640px) 100vw, (max-width: 1200px) 100vw, 100vw",
                                    priority: i === 0,
                                    quality: i === 0 ? 85 : 75,
                                    objectFit: "cover",
                                    loading: i === 0 ? "eager" : "lazy",
                                    unoptimized: true
                                })
                            ]
                        })
                    }, i);
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                h: "800px",
                bg: "gray.400"
            })
        ]
    });
};


/***/ }),

/***/ 9646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionDining; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(870);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8352);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1914);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1127);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9741);
/* harmony import */ var _CardLogo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2273);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









function SectionDining(param1) {
    var _bg = param1.bg, bg = _bg === void 0 ? "gray.100" : _bg, _color = param1.color, color = _color === void 0 ? "black" : _color, _params = param1.params, params = _params === void 0 ? {} : _params;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var ref = (0,_utils_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useDining */ .G)(_objectSpread({}, params, {
        cct_status: "publish"
    })), data = ref.data, isError = ref.isError, isLoading = ref.isLoading;
    var ref1 = (0,_utils_mediaQuery__WEBPACK_IMPORTED_MODULE_7__/* .useLargeQuery */ .fc)(), isLarge = ref1.isLarge, is2XLarge = ref1.is2XLarge, isXLarge = ref1.isXLarge, is3XLarge = ref1.is3XLarge;
    if (!data || isError || data.length <= 0) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Section__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        bg: bg,
        color: color,
        className: "section-swiper-animate",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                    mb: 2,
                    as: "h2",
                    fontWeight: 400,
                    letterSpacing: "wider",
                    children: locale == "id" ? "Restoran" : "Dining"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                    mb: 8,
                    children: locale == "id" ? "Manjakan lidah Anda dengan masakan khas lokal dan internasional di seluruh restoran kami." : "Indulge your palate with local and international cuisines all of our\n          restaurants."
                }),
                data && (data.length > 3 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .tq, {
                    slidesPerView: isLarge ? is2XLarge ? Math.min(data.length, 3) : Math.min(data.length, 2) : Math.min(data.length, 1),
                    spaceBetween: 30,
                    loop: true,
                    speed: 1000,
                    autoplay: {
                        delay: 8000,
                        pauseOnMouseEnter: true,
                        disableOnInteraction: false
                    },
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Autoplay */ .pt,
                        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl
                    ],
                    pagination: {
                        clickable: true
                    },
                    className: "mySwiper",
                    children: data.map(function(param, i) {
                        var name = param.name, hotel_name = param.hotel_name, thumb = param.thumb, logo = param.logo, _ID = param._ID;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardLogo__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                primary: name,
                                secondary: hotel_name,
                                thumb: thumb,
                                logo: logo,
                                target: "/dining/".concat(_ID),
                                type: "dining"
                            })
                        }, i);
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .tq, {
                    slidesPerView: isLarge ? Math.min(data.length, 3) : Math.min(data.length, 1),
                    spaceBetween: 30,
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl
                    ],
                    pagination: {
                        clickable: true
                    },
                    className: "mySwiper",
                    children: data.map(function(param, i) {
                        var name = param.name, hotel_name = param.hotel_name, thumb = param.thumb, logo = param.logo, _ID = param._ID;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardLogo__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                primary: name,
                                secondary: hotel_name,
                                thumb: thumb,
                                logo: logo,
                                target: "/dining/".concat(_ID),
                                type: "dining"
                            })
                        }, i);
                    })
                }))
            ]
        })
    });
};


/***/ }),

/***/ 3934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SectionEvent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/index.mjs + 808 modules
var dist = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/layout/Section.jsx
var Section = __webpack_require__(1914);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
// EXTERNAL MODULE: ./src/components/LinkTo.jsx
var LinkTo = __webpack_require__(6269);
;// CONCATENATED MODULE: ./src/components/CardSimple.jsx





function CardSimple(param) {
    var name = param.name, thumb = param.thumb, desc = param.desc, isMain = param.isMain, target = param.target;
    var ref = (0,router.useRouter)(), push = ref.push, locale = ref.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
        h: isMain ? {
            base: "55vh",
            sm: "58vh",
            md: "60vh",
            xl: "66vh"
        } : {
            base: "100%",
            lg: "66vh"
        },
        cursor: "pointer",
        onClick: function() {
            push(target);
        },
        children: isMain ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
            h: "100%",
            position: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    zIndex: 3,
                    w: "100%",
                    h: "100%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        justify: "flex-end",
                        direction: "column",
                        color: "white",
                        p: "6%",
                        h: "100%",
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                                as: "h3",
                                fontSize: "xl",
                                fontWeight: 400,
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                fontSize: "md",
                                className: "max-text-2-line",
                                color: "gray.200",
                                children: desc
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                                    fontSize: "sm",
                                    color: "gray.300",
                                    to: target,
                                    activeColor: "gray.300",
                                    children: locale == "id" ? "Lebih Lanjut" : "Learn More"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                    position: "absolute",
                    bg: "blackAlpha.500",
                    bottom: 0,
                    zIndex: 2,
                    height: "100%",
                    width: "100%",
                    background: "linear-gradient(0deg, rgba(0,0,0,0.7) 15%, rgba(0,0,0,0) 75%)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Image */.Eep, {
                    zIndex: 1,
                    h: "100%",
                    w: "100%",
                    objectFit: "cover",
                    src: (0,functions/* convertImgHttps */.Nu)(thumb),
                    alt: ""
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
            direction: "column",
            // justify="space-between"
            h: "100%",
            cursor: "pointer",
            onClick: function() {
                push(target);
            },
            gap: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                    direction: "column",
                    gap: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* AspectRatio */.oM5, {
                            ratio: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Image */.Eep, {
                                src: (0,functions/* convertImgHttps */.Nu)(thumb),
                                alt: "",
                                objectFit: "cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                            as: "h3",
                            fontSize: "xl",
                            fontWeight: 400,
                            noOfLines: 1,
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                            fontSize: "md",
                            className: "max-text-2-line",
                            color: "gray.600",
                            h: "3rem",
                            children: desc
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* default */.Z, {
                        activeColor: "gray.300",
                        fontSize: "sm",
                        color: "gray.400",
                        mt: [
                            3,
                            0
                        ],
                        to: target,
                        children: locale == "id" ? "Lebih Lanjut" : "Learn More"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/SectionEvent.tsx





function SectionEvent(param1) {
    var _color = param1.color, color = _color === void 0 ? "black" : _color, items = param1.items;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        bg: "white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                    mb: 8,
                    color: color,
                    as: "h2",
                    fontWeight: 400,
                    letterSpacing: "wider",
                    children: locale == "id" ? "RAPAT & ACARA" : "MEETING & EVENTS"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                    gap: 6,
                    flexWrap: "wrap",
                    children: items.map(function(param, i) {
                        var title = param.title, desctiption = param.desctiption, target = param.target, thumbnail = param.thumbnail;
                        if (i == 0) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                flex: items.length == 3 ? 2 : 1,
                                flexBasis: {
                                    base: "100%",
                                    lg: "0%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSimple, {
                                    name: title,
                                    desc: desctiption,
                                    thumb: thumbnail,
                                    target: target,
                                    isMain: true
                                })
                            }, i);
                        } else {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSimple, {
                                    name: title,
                                    desc: desctiption,
                                    thumb: thumbnail,
                                    target: target,
                                    isMain: items.length == 2 ? true : false
                                })
                            }, i);
                        }
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 2493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionGallery; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_image_lightbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2879);
/* harmony import */ var react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3955);
/* harmony import */ var react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1914);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9735);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1127);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9741);
/* harmony import */ var _LoadingSpinner__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8506);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











function SectionGallery(param) {
    var _color = param.color, color = _color === void 0 ? "black" : _color, _limit = param.limit, limit = _limit === void 0 ? 4 : _limit, slug = param.slug, id = param.id, _type = param.type, type = _type === void 0 ? "hotels" : _type;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), data = ref2[0], setData = ref2[1];
    var ref3 = _slicedToArray((0,_utils_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useFetchSWRv2 */ .bX)(type, {
        _ID: id,
        cct_status: "publish"
    }), 3), hotels = ref3[0], isLoading = ref3[1], isError = ref3[2];
    var limitParam = type == "dining" ? 4 : limit !== null && limit !== void 0 ? limit : 12;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(limitParam), limitCount = ref4[0], setLimitCount = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var temp;
        if (type == "hotels" && hotels && hotels[0].hotel_gallery && hotels[0].hotel_gallery.length > 0) {
            temp = _toConsumableArray(hotels[0].hotel_gallery);
            if (limitCount) {
                temp = temp.slice(0, limitCount);
            }
        } else if (type == "dining" && hotels && hotels[0].gallery && hotels[0].gallery.length > 0) {
            temp = _toConsumableArray(hotels[0].gallery);
            if (limitCount) {
                temp = temp.slice(0, limitCount);
            }
        }
        setData(temp);
    }, [
        hotels,
        limit,
        limitCount
    ]);
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), imgSrc = ref6[0], setImgSrc = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isModalOpen = ref7[0], setIsModalOpen = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), photoIdx = ref8[0], setPhotoIdx = ref8[1];
    // useOutsideClick({
    //   ref: ref,
    //   handler: () => setIsModalOpen(false),
    // });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                bg: "white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                        mb: 2,
                        as: "h2",
                        fontWeight: 400,
                        letterSpacing: "wider",
                        color: color,
                        children: router.locale == "id" ? "Galeri" : "Gallery"
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LoadingSpinner__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}) : data && data.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .SimpleGrid */ .MIq, {
                        columns: [
                            2,
                            3,
                            4
                        ],
                        spacing: [
                            4,
                            4,
                            6,
                            6,
                            8
                        ],
                        children: data.map(function(img, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AspectRatio */ .oM5, {
                                ratio: 1,
                                bg: "".concat(color, "40"),
                                cursor: "pointer",
                                onClick: function() {
                                    setPhotoIdx(i);
                                    setImgSrc((0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .convertImgHttps */ .Nu)(img.url));
                                    setIsModalOpen(true);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Eep, {
                                    src: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .convertImgHttps */ .Nu)(img.url),
                                    alt: "gallery image ".concat(i + 1),
                                    objectFit: "cover",
                                    h: "100%",
                                    w: "100%",
                                    loading: "lazy"
                                })
                            }, img.id);
                        })
                    }),
                    hotels && hotels.length > 0 && (hotels[0].hotel_gallery || hotels[0].gallery) && (limitCount < ((ref = hotels[0].hotel_gallery) === null || ref === void 0 ? void 0 : ref.length) || limitCount < ((ref1 = hotels[0].gallery) === null || ref1 === void 0 ? void 0 : ref1.length)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                        mt: limit == null ? _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_9__/* .safeMarginX */ .Mp : 0,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            variant: "dark",
                            bg: color,
                            _hover: {
                                bg: "white",
                                color: color,
                                borderColor: color,
                                borderWidth: 1
                            },
                            borderColor: color,
                            onClick: function() {
                                if (limit == null) {
                                    setLimitCount(limitCount + (type == "dining" ? 4 : 12));
                                } else {
                                    router.push(slug ? "/".concat(slug, "/gallery") : "/gallery");
                                }
                            },
                            children: router.locale == "id" ? "Lebih Banyak" : "See More"
                        })
                    })
                ]
            }),
            isModalOpen && data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_image_lightbox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainSrc: data[photoIdx].url,
                nextSrc: data[(photoIdx + 1) % data.length],
                prevSrc: data[(photoIdx + data.length - 1) % data.length],
                onCloseRequest: function() {
                    return setIsModalOpen(false);
                },
                onMovePrevRequest: function() {
                    return setPhotoIdx((photoIdx + data.length - 1) % data.length);
                },
                onMoveNextRequest: function() {
                    return setPhotoIdx((photoIdx + 1) % data.length);
                }
            })
        ]
    });
};


/***/ }),

/***/ 9938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionHotel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8352);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(870);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1914);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1127);
/* harmony import */ var _CardLogo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2273);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9741);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7239);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);










function SectionHotel(param1) {
    var _bg = param1.bg, bg = _bg === void 0 ? "gray.100" : _bg, _color = param1.color, color = _color === void 0 ? "black" : _color;
    // const { data, isError, isLoading } = useFetchSWR("hotel_list");
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)().locale;
    var ref = (0,_utils_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useGetListHotel */ .e7)(), hotels = ref.hotels, isError = ref.isError, isLoading = ref.isLoading;
    var ref1 = (0,_utils_mediaQuery__WEBPACK_IMPORTED_MODULE_7__/* .useLargeQuery */ .fc)(), isLarge = ref1.isLarge, is2XLarge = ref1.is2XLarge;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        bg: bg,
        className: "section-swiper-animate",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
            color: color,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                    mb: 2,
                    as: "h2",
                    fontWeight: 400,
                    letterSpacing: "wider",
                    children: locale == "id" ? "Hotel" : "Hotels"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                    mb: 8,
                    children: locale == "id" ? "Lebih hemat memesan kamar bersama kami ketika hendak merencanakan perjalanan Anda." : "Book direct and save more when you stay at our hotel."
                }),
                hotels && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
                    speed: 1000,
                    autoplay: {
                        delay: 8000,
                        pauseOnMouseEnter: true,
                        disableOnInteraction: false
                    },
                    loop: true,
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Autoplay */ .pt,
                        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl
                    ],
                    slidesPerView: isLarge ? is2XLarge ? Math.min(hotels.length, 3) : Math.min(hotels.length, 2) : Math.min(hotels.length, 1),
                    spaceBetween: 30,
                    pagination: {
                        clickable: true
                    },
                    className: "mySwiper",
                    children: hotels.map(function(param, i) {
                        var name = param.name, brand = param.brand, hotel_location = param.hotel_location, thumbnail = param.thumbnail, logo_light = param.logo_light, slug = param.slug;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardLogo__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                primary: brand,
                                secondary: hotel_location,
                                thumb: thumbnail,
                                logo: logo_light,
                                target: "/".concat(slug),
                                type: "hotel"
                            })
                        }, i);
                    })
                })
            ]
        })
    });
};


/***/ })

}]);